export const ONBOARDING_LEVEL_LABEL = {
  beginner: '초급',
  upperBeginner: '초중급',
  intermediate: '중급',
  preAdvanced: '중고급',
  advanced: '고급',
  starter: '왕초보',
} as const

type OnboardingLanguageCode = 'en' | 'ja' | 'ko'
type OnboardingLevelMessageKeyMap = Record<OnboardingLanguageCode, Record<string, string | undefined>>

export const EN_ONBOARDING_LEVEL_LABELS = [
  ONBOARDING_LEVEL_LABEL.beginner,
  ONBOARDING_LEVEL_LABEL.intermediate,
  ONBOARDING_LEVEL_LABEL.preAdvanced,
  ONBOARDING_LEVEL_LABEL.advanced,
] as const

export const JA_ONBOARDING_LEVEL_LABELS = [
  ONBOARDING_LEVEL_LABEL.starter,
  ONBOARDING_LEVEL_LABEL.beginner,
  ONBOARDING_LEVEL_LABEL.intermediate,
  ONBOARDING_LEVEL_LABEL.advanced,
] as const

export const KO_ONBOARDING_LEVEL_LABELS = JA_ONBOARDING_LEVEL_LABELS

export const ONBOARDING_LEVEL_LABEL_KEYS: OnboardingLevelMessageKeyMap = {
  en: {
    [ONBOARDING_LEVEL_LABEL.beginner]: 'onboarding.flow.level.en.beginner',
    [ONBOARDING_LEVEL_LABEL.intermediate]: 'onboarding.flow.level.en.intermediate',
    [ONBOARDING_LEVEL_LABEL.preAdvanced]: 'onboarding.flow.level.en.preAdvanced',
    [ONBOARDING_LEVEL_LABEL.advanced]: 'onboarding.flow.level.en.advanced',
  },
  ja: {
    [ONBOARDING_LEVEL_LABEL.starter]: 'onboarding.flow.level.ja.starter',
    [ONBOARDING_LEVEL_LABEL.beginner]: 'onboarding.flow.level.ja.beginner',
    [ONBOARDING_LEVEL_LABEL.intermediate]: 'onboarding.flow.level.ja.intermediate',
    [ONBOARDING_LEVEL_LABEL.advanced]: 'onboarding.flow.level.ja.advanced',
  },
  ko: {
    [ONBOARDING_LEVEL_LABEL.starter]: 'onboarding.flow.level.ko.starter',
    [ONBOARDING_LEVEL_LABEL.beginner]: 'onboarding.flow.level.ko.beginner',
    [ONBOARDING_LEVEL_LABEL.intermediate]: 'onboarding.flow.level.ko.intermediate',
    [ONBOARDING_LEVEL_LABEL.advanced]: 'onboarding.flow.level.ko.advanced',
  },
}

export const ONBOARDING_LEVEL_DESCRIPTION_KEYS: OnboardingLevelMessageKeyMap = {
  en: {
    [ONBOARDING_LEVEL_LABEL.beginner]: 'onboarding.flow.levelDescription.en.beginner',
    [ONBOARDING_LEVEL_LABEL.intermediate]: 'onboarding.flow.levelDescription.en.intermediate',
    [ONBOARDING_LEVEL_LABEL.preAdvanced]: 'onboarding.flow.levelDescription.en.preAdvanced',
    [ONBOARDING_LEVEL_LABEL.advanced]: 'onboarding.flow.levelDescription.en.advanced',
  },
  ja: {
    [ONBOARDING_LEVEL_LABEL.starter]: 'onboarding.flow.levelDescription.ja.starter',
    [ONBOARDING_LEVEL_LABEL.beginner]: 'onboarding.flow.levelDescription.ja.beginner',
    [ONBOARDING_LEVEL_LABEL.intermediate]: 'onboarding.flow.levelDescription.ja.intermediate',
    [ONBOARDING_LEVEL_LABEL.advanced]: 'onboarding.flow.levelDescription.ja.advanced',
  },
  ko: {
    [ONBOARDING_LEVEL_LABEL.starter]: 'onboarding.flow.levelDescription.ko.starter',
    [ONBOARDING_LEVEL_LABEL.beginner]: 'onboarding.flow.levelDescription.ko.beginner',
    [ONBOARDING_LEVEL_LABEL.intermediate]: 'onboarding.flow.levelDescription.ko.intermediate',
    [ONBOARDING_LEVEL_LABEL.advanced]: 'onboarding.flow.levelDescription.ko.advanced',
  },
}
